import { render, staticRenderFns } from "./CompatibilityChecker.vue?vue&type=template&id=27ef2761"
import script from "./CompatibilityChecker.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompatibilityChecker.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports